import { useEffect, useState } from "react";
import "./App.css";
import { authenticate, getDivisions } from "./utilities/genesysCloudUtils";
import { Loading } from "./components/Loading";
import { LeftPanel } from "./components/LeftPanel";
import { Body } from "./components/Body";

const DARK_THEME_ENABLED_KEY = "dark-theme";

function App() {
  const [auth, setAuth] = useState(false);
  const [loadingText, setLoadingText] = useState("Authenticating...");
  const [darkThemeEnabled, setDarkThemeEnabled] = useState(
    localStorage.getItem(DARK_THEME_ENABLED_KEY) === "true"
  );
  const [divisions, setDivisions] = useState([]);
  const [checkedDivisions, setCheckedDivisions] = useState([]);
  const [searchQueues, setSearchQueues] = useState("");
  const [searchWrapupCodes, setSearchWrapupCodes] = useState("");
  const [org, setOrg] = useState(null);

  useEffect(() => {
    if (!org) {
    authenticate("DEV")
      .then(() => {
        setAuth(true);
      })
      .then(() => {
        getDivisions().then((data) => {
          setDivisions(data.entities);
        });
      });
    } else {
      console.log("ORG:", org);
      authenticate(org)
        .then(() => {
          setAuth(true);
        })
        .then(() => {
          getDivisions().then((data) => {
            setDivisions(data.entities);
          });
        });
    }
  }, [org]);

  useEffect(() => {
    // Save theme setting
    localStorage.setItem(
      DARK_THEME_ENABLED_KEY,
      darkThemeEnabled ? "true" : ""
    );
  }, [darkThemeEnabled]);

  return (
    <div
      className={`app-container my-app${
        darkThemeEnabled ? "-dark" : "-light"
      } disappearing-scrollbars`}
    >
      {auth ? (
        <>
          <LeftPanel
            darkThemeEnabled={darkThemeEnabled}
            setDarkThemeEnabled={setDarkThemeEnabled}
            divisions={divisions}
            checkedDivisions={checkedDivisions}
            setCheckedDivisions={setCheckedDivisions}
            searchQueues={searchQueues}
            setSearchQueues={setSearchQueues}
            searchWrapupCodes={searchWrapupCodes}
            setSearchWrapupCodes={setSearchWrapupCodes}
            setOrg={setOrg}
          />
          <div className="app">
            <Body
              divisions={divisions}
              checkedDivisions={checkedDivisions}
              searchQueues={searchQueues}
              searchWrapupCodes={searchWrapupCodes}
            />
          </div>
        </>
      ) : (
        <Loading loadingText={loadingText} />
      )}
    </div>
  );
}

export default App;
